export const productUpdateSnsMessage = 'Information updated successfully'
export const productUpdateSnsErrorMessage =
  'Oops! Something went wrong. Could not subscribe to SNS Topics. Please try after some time.'
export const websiteValidationCheckMessage =
  'Provide a valid URL (Beginning with https://)'

export const productCloneSuccess = 'Product cloned successfully.'
export const productCreationSuccess = 'Listing created successfully.'
export const draftProductCreationSuccess =
  'Draft listing has been saved successfully.'
export const clearDraftProductCreationSuccess =
  'Your listing form has been cleared successfully.'
export const clearDraftProductCreationFail =
  'Your listing form could not be cleared. Please try again.'
export const draftProductCreationFail =
  'Draft could not be submitted. Please try after some time.'

export const requiredFieldMessage = 'Please enter a non-empty value.'
export const mandatoryEmailMessasge = 'At least one email is required'
export const mandatoryNumberFieldMessage = 'This field cannot be empty'
export const migrationProductRequiredMessage =
  'Select at least one product to proceed.'
export const productCategoriesProfessionalServicesMessage =
  'Please select at least one product category.'
export const buyerRegistrationPagePreviewMessage =
  'Complete all the manadatory fields to preview your buyer registration page.'

export const buyerRegistrationModalMessage =
  'This is a preview of the buyer registration page. The actual page may vary based on your configuration.'
export const eulaMandatoryFieldMessage = 'EULA is required'
export const mandatoryUsGovInTitleErrMessage =
  'Title must include "US Gov" for US Gov Cloud products'
export const mustHaveMoreWordsForGovCloudMessage =
  'Title must have more words for US Gov Cloud products'
export const doubleQuoteMessage = 'Double quotes are not allowed'
export const mandatoryFieldMessage = 'This field is required'

export const CRMAuthSuccessMessage =
  'Your CRM connection is authenticated and linked now.'

export const contractSendMessage =
  'Metering record successfully queued. Updated info will appear here in a few minutes.'

export const numberKeyToPrevent = ['+', '-', '.', 'e']

export const emptySpacesMessage =
  'Values cannot start or end with whitespace characters (space, tab, newline)'

export const listingTextRestrictionMessage =
  'Highlighted characters are not allowed.'

export const mandatoryUsGovInTitleMessage =
  'You must include "GovCloud" somewhere in your product title.'

export const ssoInviteDisableMessage =
  'Please ask your SSO admin to invite the team members to ensure they have the appropriate permissions and access.'
